import api from './api';
import dayjs, { Dayjs } from 'dayjs';

export interface UnsignedDocument {
  MaKCB: string;
  HoTen: string;
  TenKK: string;
  TenNV: string;
  NgayTT: string;
  ThieuChuKy: string;
}

export const unsignedDocumentService = {
  async getUnsignedDocuments(
    fromDate: Dayjs,
    toDate: Dayjs
  ): Promise<UnsignedDocument[]> {
    const params = {
      fromDate: fromDate.format('YYYY-MM-DD'),
      toDate: toDate.format('YYYY-MM-DD'),
    };

    // The interceptor will handle errors, so the try/catch is removed for simplicity.
    // The component that calls this should have its own try/catch for UI feedback (e.g., loading spinners, error messages)
    // but not for auth handling.
    const response = await api.get('/unsigneddocuments', { params });
    
    // The transformation logic seems important, so we keep it.
    const data = Array.isArray(response.data) ? response.data : [];
    const transformedData = data.map((item: any) => {
      const result: any = {};
      const mappings = {
        'maKCB': 'MaKCB',
        'hoTen': 'HoTen',
        'tenKK': 'TenKK',
        'tenNV': 'TenNV',
        'ngayTT': 'NgayTT',
        'thieuChuKy': 'ThieuChuKy'
      };
      
      Object.entries(mappings).forEach(([source, target]) => {
        const pascalCaseSource = source.charAt(0).toUpperCase() + source.slice(1);
        const value = item[source] || item[pascalCaseSource];
        result[target] = value || '';
      });
      
      return result as UnsignedDocument;
    });
    
    return transformedData;
  },

  async transferPatientSignature(maKCB: string): Promise<any> {
    return api.post(`/unsigneddocuments/transfer-signature/${maKCB}`);
  },

  // Helper function to format date for display
  formatDate(dateString: string): string {
    if (!dateString) return 'N/A';
    return dayjs(dateString).format('DD/MM/YYYY');
  },
};